// extracted by mini-css-extract-plugin
module.exports = {"overlayIframe":"ScoreboardOverlay_overlayIframe__jlP1S"};